import { Component, Inject, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { EventEditComponent } from '../event-edit/event-edit.component';
import { AccountStatusService } from '../../services/accountstatus.service';
import { AssetMapService } from '../../services/assetmap.service';
import * as moment from 'moment';

@Component({
  selector: 'app-section-edit',
  templateUrl: './section-edit.component.html',
  styleUrls: ['./section-edit.component.scss']
})
export class SectionEditComponent implements OnInit, OnDestroy {
  @Input() accountsStatusData;

  public isLoading = true;
  public selectedTab = 0;
  public tabLabel = {};
  public dropDownItems = {};
  private accountsStatusData$: Subscription;
  private assetMap$: Subscription;

  public quillModules = {
    toolbar: [['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['clean']
    ]    
  }

  constructor(
    public acountsStatusService: AccountStatusService,
    private assetMapService: AssetMapService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SectionEditComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    
  }

  ngOnInit(): void {


    // Go through the definition and do any preprocessing
    // 1) Generate the drop down value arrays


    this.data.sectionDef.sections.forEach((section,i) => {

      // create an object with section titles so we can select by title
      if(section.title) this.tabLabel[section.title] = i

      section.fields.forEach(item => {

        if(item.type!="table"){

          if(item.type=="dropdown" && !(item.readonly && item.readonly === true)){
            this.dropDownItems[item.name] = this.getDropDownItems(item.values)
          }
    
          // if there is a name field then create a value to match
          if(item['name']){
            if(this.data.data[item['name']]==undefined){
              this.data.data[item['name']] = {id:"",propertyname:item['name'],propertytext:'',newtext:'',accountid:this.data.account["id"],versionid:this.data.versionid};        
            } else {
              this.data.data[item['name']]['newtext'] = this.data.data[item['name']]['propertytext'];
            }
          }

        } else {

          // do same thing for fields in a table
          if(item.fields) {
            this.buildFieldsData(item.fields);
          }

          // same for shortened row format
          if(item.rows)
          item.rows.forEach(tableRowItem => {
            tableRowItem.forEach((tableItem,i) => {
              // first entry is the row label so ignore that
              if(i>0){
                if(this.data.data[tableItem]==undefined){
                  this.data.data[tableItem] = {id:"",propertyname:tableItem,propertytext:'',newtext:'',accountid:this.data.account["id"],versionid:this.data.versionid};        
                } else {
                  this.data.data[tableItem]['newtext'] = this.data.data[tableItem]['propertytext'];
                }
              }
          });
          });

        }

        // console.log(JSON.stringify(this.data.data))
        
      });

    });


    // select the section if that has been passed
    // if it is a number do it by that - if not do it by the tab name

    if(this.data.selectTab){
      if(this.stringIsNumber(this.data.selectTab)){
        this.selectedTab = Number(this.data.selectTab)
      } else {
        if(this.tabLabel[this.data.selectTab]){
          this.selectedTab = this.tabLabel[this.data.selectTab]
        }
      }      
    }

    this.accountsStatusData$ = this.acountsStatusService.accountsStatus$.subscribe(
      (responsedata: any) => {
        if(responsedata!=null){
          if(!responsedata.loading){
            if(responsedata.data.length>0){
              responsedata.data.forEach(item => {
                if(item['propertyname']){
                  this.data.data[item['propertyname']] = item;
                  this.data.data[item['propertyname']]['newtext'] = this.data.data[item['propertyname']]['propertytext'];
                }
              });
              this.buildTableRow();
            }
            setTimeout(() => {
              this.isLoading = true;
            },1000)
          }
        }
      }
    );

    this.assetMap$ = this.assetMapService.assetMap$.subscribe(
      (responsedata: any) => {
        if (responsedata != null) {
          if (!responsedata.loading) {
            if (responsedata.data.length > 0) {
              responsedata.data.forEach(item => {
                if (item['propertyname']) {
                  this.data.data[item['propertyname']] = item;
                  this.data.data[item['propertyname']]['newtext'] = this.data.data[item['propertyname']]['propertytext'];
                }
              });
            }
            this.buildMultiItemTableRow();
            this.isLoading = true;
          }
        }
      }
    );

    if (this.data.tableTitleId) {
      setTimeout(() => {
        const ele = document.getElementById(this.data.tableTitleId);
        if (ele) {
          ele.scrollIntoView(true);
        }
      }, 100);
    }
  }

  ngOnDestroy(): void {
    this.accountsStatusData$.unsubscribe();
    this.assetMap$.unsubscribe();
  }

  buildFieldsData(fields: any[]) {
    if (Array.isArray(fields)) {
      fields.forEach(tableRowItem => {
        this.buildFieldData(tableRowItem)
      });
    }
  }

  buildFieldData(tableRowItem: any[]) {
    if (Array.isArray(tableRowItem)) {
      tableRowItem.forEach(tableItem => {
        // console.log('table item:' + JSON.stringify(tableItem))
        if (tableItem.type == "dropdown" && !(tableItem.readonly && tableItem.readonly === true)) {
          this.dropDownItems[tableItem.name] = this.getDropDownItems(tableItem.values)
        }
  
        // if there is a name field then create a value to match
        if (tableItem['name']) {
          if (this.data.data[tableItem['name']] == undefined) {
            this.data.data[tableItem['name']] = { id: "", propertyname: tableItem['name'], propertytext: '', newtext: '', accountid: this.data.account["id"], versionid: this.data.versionid };
          } else {
            this.data.data[tableItem['name']]['newtext'] = this.data.data[tableItem['name']]['propertytext'];
          }
        }
      });
    }
  }
  
  getType(item){
    const types = [
      'dropdown',
      'formattedtext',
      'break',
      'header',
      'table',
      'label',
      'number'
    ];
    
    if(item["readonly"] && item["readonly"]===true){
      return "readonly";
    } else if (types.includes(item['type'])) {
      return item['type'];
    } else {
      return "string"
    }
  }

  // sort out the values option of the dropdown - allow simple array or array of objects with label and value properties - if
  // label is missing use the value
  getDropDownItems(vals){

    let rtn = [];
    if(Array.isArray(vals)){
      vals.forEach(x => {
        if(typeof x === 'object'){
          rtn.push({value:x["value"],label:x["label"]?x["label"]:x["value"]})
        } else {
          rtn.push({'value':x,'label':x})
        }
      });      
    }

    // console.log("--" + JSON.stringify(rtn))
    return rtn;

  }

  save():void {
    let newdata = {...this.data.data};
    this.dialogRef.close(newdata);
  }

  close(){
    this.dialogRef.close("cancel");
  }

  stringIsNumber(s) {
    return !isNaN(parseFloat(s)) && !isNaN(s - 0)
  }

  
  // if the first cell of the row is a label and is marked with total="Y" OR total="N"
  // there is not total property then if the label string includes the word total
  isTotal(row){
    if(row[0].type=="label"){
      if(row[0].total){
        return (row[0].total.trim().toLowerCase().substr(0,1)=="y"?"total":"")
      } else {
        if(row[0].label && row[0].label.toLowerCase().includes("total")){
          return "total"
        } else {
          return ""
        }
      }
    }
  }

  isRowTotal(row){
    if(row[0].toLowerCase().includes("total")) {
      return "total"
    } else {
      return ""
    }    
  }

  editorInit(quill: any){
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, function(node, delta){
      delta.forEach(e => {
        // remove any funny no length spaces
        if(e["insert"] && typeof e["insert"] == "string"){
          e["insert"] = e["insert"].replace(/[\u200B-\u200D\uFEFF]/g,'')
        }
        
        // remove any color properties
        if(e.attributes){
          e.attributes.color = '';
          e.attributes.background = '';
        }
      });
      return delta;
    });
  }

  editRow(accountData,row){
    let data = {
      data: accountData,
      row: row
    }

    let newdata = this.deepCopy(data);

    let dialogRef = this.dialog.open(EventEditComponent, {
      height: '600px',
      width: '700px',
      data: newdata,
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){
      
      } else if(result!=undefined){
        this.isLoading = false;
        this.selectedTab = this.tabLabel["Events"];
        // save to the database
        this.updateStatusData(result);
      }
    }) 
  }

  updateStatusData(data) {
    let uData = [];
    Object.keys(data).forEach(x => {
      let drow = data[x];

      if (drow["newtext"] !== undefined) {
        let newtext="";
        let oldtext="";
        if(drow["newtext"] instanceof Object){
          newtext = (drow["newtext"] == null ? "" : this.formatDate(drow["newtext"]._d).trim());       
        }else{
          newtext = (drow["newtext"] == null ? "" : drow["newtext"].trim());
        }
        if(drow["propertytext"] instanceof Object){
          oldtext = (drow["propertytext"] == null ? "" : this.formatDate(drow["propertytext"]._d).trim());        
        }else{
          oldtext = (drow["propertytext"] == null ? "" : drow["propertytext"].trim());
        }
        if (newtext != oldtext) {
          drow["propertytext"] = drow["newtext"];
          uData.push({
            "id": drow["id"],
            "accountid": drow["accountid"],
            "versionid": drow["versionid"],
            "propertyname": x, 
            "propertytext": newtext
          })
        }
      }
    });
    this.acountsStatusService.updateStatus(uData);
  }

  deleteRow(row, index){
    if(confirm("Are you sure to delete this event?")){
      let deleteEvents=[]; 
      this.data.sectionDef.sections.forEach(item => {
        if(item.title == "Events"){
          item.fields[0]["fields"].splice(index, 1);
        }
      });
      row.forEach(item => {
        if(item['name']){
          if(this.data.data[item['name']]){
            deleteEvents.push({"id":this.data.data[item['name']].id, "accountid":this.data.data[item['name']].accountid});
            delete this.data.data[item['name']];
          } 
        }
      });
      if(deleteEvents.length>0){
        this.isLoading = false;
        this.selectedTab = this.tabLabel["Events"];
        this.acountsStatusService.deleteEvent(deleteEvents);
      }
    }
  }

  addRow(accountData){
    let maxNum = this.getEventRows(accountData.data).length>0?this.getEventRows(accountData.data)[this.getEventRows(accountData.data).length-1]:0;
    let data = {
      data: accountData,
      row: [{"name":"ev_date_"+(maxNum+1),"type":"date",label:"Date",readonly:true,isRequired:true},
        {"name":"ev_title_"+(maxNum+1),"type":"formattedtext",label:"Title",readonly:true,isRequired:true},
        {"name":"ev_desc_"+(maxNum+1),"type":"formattedtext",label:"Description",readonly:true},
        {"name":"ev_contributor_"+(maxNum+1),"type":"string",label:"Contributor",readonly:true}]
    }

    let newdata = this.deepCopy(data);   

    let dialogRef = this.dialog.open(EventEditComponent, {
      height: '600px',
      width: '700px',
      data: newdata
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){
        
      } else if(result!=undefined){
        this.isLoading = false;
        this.selectedTab = this.tabLabel["Events"];
        // save to the database
        this.updateStatusData(result);
      }
    }) 
  }

  // deep copy of Object
  private deepCopy(obj) {
    return Object.keys(obj).reduce((v, d) => Object.assign(v, {
      [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
    }), {});
  }

  getEventRows(accountsStatusData){
    // work out how many rows of status things there are - have 5 as the default number
    let rtn = [];
    Object.keys(accountsStatusData).forEach(x => {
        let tmpnm = "";
        if(x.startsWith("ev_title_")){
          tmpnm = x.replace("ev_title_","");
          if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
            rtn.push(parseFloat(tmpnm));
          }
        };
        if(x.startsWith("ev_desc_")){
          tmpnm = x.replace("ev_desc_","");
          if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
            rtn.push(parseFloat(tmpnm));
          }
        };
        if(x.startsWith("ev_date_")){
          tmpnm = x.replace("ev_date_","");
          if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
            rtn.push(parseFloat(tmpnm));
          }
        };
        if(x.startsWith("ev_contributor_")){
          tmpnm = x.replace("ev_contributor_","");
          if(this.stringIsNumber(tmpnm)&&!this.isInArray(rtn,parseFloat(tmpnm))){
            rtn.push(parseFloat(tmpnm));
          }
        };
    })
    if(rtn.length>0){
      rtn.sort(function(a, b){return a - b}); 
    }
    return rtn;
  }

  isInArray(arr,value){
    for(var i = 0; i < arr.length; i++){
        if(value === arr[i]){
            return true;
        }
    }
    return false;
  }

  formatDate(date){
    return moment(new Date(date)).format("DD/MMM/YYYY");
  }

  buildTableRow(){
    let eventNums = [];
    this.data.sectionDef.sections.forEach(item => {
      if(item.title == "Events"){
        item.fields[0]["fields"] = [];
        eventNums=this.getEventRows(this.data.data);
        if(eventNums.length>0){
          eventNums.forEach(num => {
            let temp=[];
            temp.push({"name":"ev_date_"+num,"type":"date","readonly":true,label:"Date",isRequired:true});
            temp.push({"name":"ev_title_"+num,"type":"formattedtext","readonly":true,label:"Title",isRequired:true});
            temp.push({"name":"ev_desc_"+num,"type":"formattedtext","readonly":true,label:"Description"});
            temp.push({"name":"ev_contributor_"+num,"type":"string","readonly":true,label:"Contributor"});
            item.fields[0]["fields"].push(temp);
          });
        }
      }
    });
  }

  buildMultiItemTableRow() {
    this.data.sectionDef.sections.forEach(item => {
      if (Array.isArray(item.fields)) {
        item.fields.forEach(itm => {
          if (itm.multipleItems && Array.isArray(itm.fieldNames)) {
            this.buildMultiItemFields(this.data.data, itm);
            this.buildFieldsData(itm.fields);
          }
        });
      }
    });
  }

  getMultiItemRows(data: any, fields: any[]) {
    let rtn = [];
    if (data && Array.isArray(fields)) {
      const suffix = '_te';
      Object.keys(data).forEach(x => {
        let tmpnm = '';
        fields.forEach(field => {
          if (field && field.name) {
            const { name } = field;
            const isTotalEstateField = name.endsWith(suffix);
            const prefix = `${isTotalEstateField ? name.substring(0, name.length - 3) : name}-`;
            if (x.startsWith(prefix)) {
              let valid = true;
              tmpnm = x.replace(prefix, '');
              if (isTotalEstateField) {
                if (x.endsWith(suffix)) {
                  tmpnm = tmpnm.replace(suffix, '');
                } else {
                  valid = false;
                }
              }

              if (valid) {
                if (this.stringIsNumber(tmpnm) && !this.isInArray(rtn, parseFloat(tmpnm))) {
                  rtn.push(parseFloat(tmpnm));
                }
              }
            }
          }
        });
      });

      if (rtn.length > 0) {
        rtn.sort(function (a, b) { return a - b });
      }
    }

    return rtn;
  }

  buildMultiItemFields(data: any, item: any) {
    item.fields = [];
    const nums = this.getMultiItemRows(data, item.fieldNames);
    if (nums.length > 0) {
      let fields = [];
      nums.forEach(num => {
        const temp = item.fieldNames.map(field => {
          return this.buildMultiItemField(field, num);
        });
        fields.push(temp);
      });
      item.fields = fields;
    }
  }

  buildMultiItemField(field: any, num: number) {
    const suffix = '_te';
    const { name } = field;
    if (name) {
      const isTotalEstateField = name.endsWith(suffix);
      const prefix = `${isTotalEstateField ? name.substring(0, name.length - 3) : name}-`;
      return {
        ...field,
        name: isTotalEstateField ? `${prefix}${num}${suffix}` : `${prefix}${num}`
      };
    }
    return field;
  }

  addMultiItemRow(data: any, item: any) {
    const rows = this.getMultiItemRows(data, item.fieldNames);
    const maxNum = rows.length > 0 ? rows[rows.length - 1] : 0;
    const newItem = item.fieldNames.map(field => {
      return this.buildMultiItemField(field, maxNum + 1);
    });
    this.buildFieldData(newItem);
    item.fields = item.fields.concat([newItem]);
  }

  deleteMultiItemRow(row: any[], index: number, item: any) {
    if (confirm('Are you sure to delete this row?')) {
      let deleteRows = [];
      item.fields.splice(index, 1);
      row.forEach(item => {
        if (item['name']) {
          const itm = this.data.data[item['name']];
          if (itm) {
            if (itm.id) {
              deleteRows.push({
                ...itm
              });
            }
            delete this.data.data[item['name']];
          }
        }
      });

      if (deleteRows.length > 0) {
        this.isLoading = false;
        this.assetMapService.deleteAssetMapData(deleteRows);
      }
    }
  }

  getHeaderBackground(label: string) {
    let background = '';

    switch (label) {
      case 'DXC Managed':
        background = '#969696';
        break;
      case 'Total Estate':
        background = '#C6C6C6';
        break;
      default:
        break;
    }

    return background;
  }
}
